<template>
  <div class="card">

    <div class="card-header">
      <p class="card-header-title">{{trans.user_avatar}}</p>
    </div>

    <div class="card-content field-label-container">

      <div class="columns">

        <div class="avatar">
          <img v-if="photoUrl" :src="photoUrl" @error="hideAvatar">
          <i v-show="isEmptyUrl" class="fas fa-user-circle fa-10x"></i>
        </div>

        <div class="column ml-1 mt-1">

          <div class="field">
            <label for="profile_photo" class="button is-info"
                   :class="{'is-loading': isLoading }"
            >
              {{trans.upload}}
            </label>
            <input type="file" id="profile_photo" accept="image/png, image/jpeg"
                   @change="uploadUserAvatar"
            >
          </div>

          <div class="field">
            <button type="submit" class="button is-info"
                    :disabled="isEmptyUrl"
                    @click="deleteUserAvatar"
            >
              {{trans.delete}}
            </button>
          </div>

          <div class="field" v-show="errors">
            <p class="help is-danger" v-html="errors"></p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosForm } from '../mixins/axiosFormMixin';

export default {
  name: "ProfileUserAvatar",
  mixins: [
    axiosForm,
  ],
  props: {
    trans: Object,
    actions: Object,
    avatarUrl: String,
  },
  data() {
    return {
      photoUrl: this.avatarUrl,
      errors: '',
    };
  },
  computed: {
      isEmptyUrl() {
          return !this.photoUrl;
      },
  },
  methods: {
    postResultHandler(response) {
      this.photoUrl = response.data.url;
    },
    postErrorHandler(error) {
      let status = error.response.status,
          errorString = '';

      switch (status) {
        case 422:
          let errorList = error.response.data.errors;
          for (let error in errorList) {
            errorString += `${errorList[error][0]}<br>`;
          }
          break;
        case 413:
          errorString += `${this.trans.file_size_is_too_large}<br>`;
          break;
      }

      this.errors = errorString;
    },
    uploadUserAvatar(e) {
      this.errors = '';

      let formData = new FormData();
      formData.append('photo', e.target.files[0]);

      let config = { 'content-type': 'multipart/form-data' };

      this.isLoading = true;

      this.sendRequest(this.actions.upload, formData, 'post', config);

    },
    deleteUserAvatar() {
      this.sendRequest(this.actions.delete, {}, 'post');
    },
    hideAvatar() {
        this.photoUrl = '';
    },
  }
}
</script>

<style scoped>
.avatar {
  margin: 0.7rem 1rem;
  color: #aaa9a9;
}
.avatar img {
  border-radius: 50%;
  height: 10rem;
  width: 10rem;
}
#profile_photo {
  display: none;
}
.button {
  width: 145px;
}
</style>